<!--  -->
<template>
  <div class="to-arrow-box" v-show="isShow" @click="toTop">
    <div v-show="!isHover" class="to-arrow-wrapper" @mouseenter="enter" @mouseover="enter" @mouseout="leave">
      <img src="../../assets/images/arrow_top_nor.png">
    </div>
    <div v-show="isHover" class="to-arrow-wrapper-active" @mouseenter="enter" @mouseover="enter" @mouseout="leave">
      <img src="../../assets/images/arrow_top_pre.png">
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      isShow: false,
      isHover: false
    }
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  created () {},

  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 150) {
        this.isShow = true;
      } else if (scrollTop < 150) {
        this.isShow = false;
      }
    },
    toTop() {
      this.isHover = false
      var top = 0
      $('html,body').animate({scrollTop: top}, 500)
    },
    enter() {
      this.isHover = true
    },
    leave() {
      this.isHover = false
    }
  }
}

</script>
<style lang='scss' scoped>
.to-arrow-box {
  position: fixed;
  top:75%;
  right: 0;
  z-index:10;
  border-top: 1px #fff solid;
  .to-arrow-wrapper {
    width: 80px;
    height: 80px;
    background: #FF789E;
    border-radius: 0 0 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      vertical-align: top\0;
      margin-top: 25px\0; 
      width: 34px;
      height: 32px;
    }
  }
  .to-arrow-wrapper-active {
    width: 80px;
    height: 80px;
    background: #FFF8FA;
    box-shadow: 0px 2px 4px 0px rgba(106,56,70, 0.2);
    border-radius: 0 0 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      vertical-align: top\0;
      margin-top: 25px\0; 
      width: 34px;
      height: 32px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/topArrow/topArrow.vue